const EVENTS = {
	CLICK: 'click',
	HOVER: 'hover',
	SCROLL: 'scroll',
};

const PAGE_ID = {
	WELCOME: 'welcomePage',
	SALESDASHBOARD: 'salesdashboardPage',
};

const PAGE_NAME = {
	WELCOME: 'Welcome',
	SALESDASHBOARD: 'Sales Dashboard',
};

const ACTION_ON = {
	EXPORT_BUTTON: 'Export',
	WEEK_SELECTION_DROPDOWN: 'SelectWeek',
	CHANNEL_BREAKDOWN_BUTTON: 'SelectChannelBreakDown',
	RULES_DELETED: 'RulesDeleted',
	RULES_DEACTIVATED: 'RulesDeactivated',
	RULES_REACTIVATED: 'RulesReactivated',
	RULES_CREATED_THRESHOLD: 'RulesCreatedThreshold',
	RULES_CREATED_COMPARISON: 'RulesCreatedComparison',
	RULES_EDITED_THRESHOLD: 'RulesEditedThreshold',
	RULES_EDITED_COMPARISON: 'RulesEditedComparison',
	CUSTOMWEEK_OPENED: 'CustomWeek_Opened',
	CUSTOMWEEK_APPLIED: 'CustomWeek_Applied',
	SEARCH_IN_HIERARCHY: 'Search in Hierarchy',
	SAVE_HIERARCHY: 'Save the preference for Hierarchy',
	UPC_SEARCH: 'UPC search',
	METRIC_DEFINITIONS: 'User viewed metric definition',
	CUSTOM_HIERARCHY: 'Custom Hierarchy Applied',
	SEARCH_METRICS: 'Search for metric names in metric selection',
	ITEM_DRILLDOWN: 'Item drilldown opened',
};

export default {
	ACTION_ON,
	EVENTS,
	PAGE_ID,
	PAGE_NAME,
};
